module.exports = __webpack_public_path__ + "static/the-rosie-effect-0dbe151831b2f123e6c0a22e4b049f29.jpg";